import Glide from '@glidejs/glide';

const desktopQuery = window.matchMedia('(min-width: 1200px)');

function isVisible(el) {
    return el.offsetParent !== null;
}

function mount(el) {
    el.__glide = new Glide(el, {
        type: 'slider',
        perView: 3,
        gap: 20,
        bound: true,
        autoplay: false,
    }).mount();
}

function destroy(el) {
    if (!el.__glide) return;

    el.__glide.destroy();
    el.__glide = null;
}

function refresh() {
    document.querySelectorAll('.plans__list.glide').forEach((el) => {
        if (!desktopQuery.matches) {
            destroy(el);
        } else if (isVisible(el)) {
            if (el.__glide) {
                el.__glide.update();
            } else {
                mount(el);
            }
        }
    });
}

let resizeTimer;
function scheduleRefresh() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(refresh, 150);
}

document.addEventListener('DOMContentLoaded', () => {
    refresh();

    document.querySelectorAll('.plans__tab').forEach((tab) => {
        tab.addEventListener('click', refresh);
    });

    window.addEventListener('resize', scheduleRefresh);

    window.addEventListener('load', refresh);
});
